import { ShoppingOutlined, FileDoneOutlined } from '@ant-design/icons-vue';
import ProductsList from '@/views/products/ProductsList.vue';
import PaymentSettings from '@/views/products/PaymentSettings.vue';
import ShippingSettings from '@/views/products/ShippingSettings.vue';
import OrdersList from '@/views/products/OrdersList.vue';
import OrderCancellations from '@/views/products/OrderCancellations.vue';
import VirtualReceipts from '@/views/products/VirtualReceipts.vue';
import ProductsCategories from '@/views/products/ProductsCategories.vue';
import Vendors from '@/views/products/Vendors.vue';
import { ORDER_DESK_PROFILE } from '@/views/products/orderDeskProfiles.js';

/** 商品目錄（不含訂單葉頁，避免訂單權限打開整棵商城） */
export const productsFolderRoute = {
    path: 'products',
    name: 'Products',
    redirect: '/products/products-list',
    meta: {
        title: '商城管理',
        icon: ShoppingOutlined
    },
    children: []
};

export const productsChildrenRoutes = [
    {
        path: 'products-type-list',
        component: ProductsCategories,
        name: 'ProductsCategories',
        meta: { title: '商品分類' }
    },
    {
        path: 'vendors',
        component: Vendors,
        name: 'ShopVendors',
        meta: { title: '廠商管理' }
    },
    {
        path: 'products-list',
        component: ProductsList,
        name: 'ProductsList',
        meta: { title: '商品列表' }
    },
    {
        path: 'payment-settings',
        component: PaymentSettings,
        name: 'PaymentSettings',
        meta: {
            title: '支付方式設定',
            hidden: true
        }
    },
    {
        path: 'shipping-settings',
        component: ShippingSettings,
        name: 'ShippingSettings',
        meta: {
            title: '物流方式設定',
            hidden: true
        }
    },
    {
        path: 'virtual-receipts',
        component: VirtualReceipts,
        name: 'VirtualReceipts',
        meta: {
            title: '虛擬商品領取紀錄',
            hidden: true
        }
    }
];

/**
 * 訂單工作面：財務／行銷／課程只看到訂單相關葉頁。
 * 路徑維持 /products/* 以相容書籤。
 */
export const orderDeskFolderRoute = {
    path: 'order-desk',
    name: 'OrderDesk',
    redirect: '/products/orders-list',
    meta: {
        title: '訂單工作面',
        icon: FileDoneOutlined
    },
    children: []
};

export const orderDeskChildrenRoutes = [
    {
        path: '/products/orders-list',
        component: OrdersList,
        name: 'OrdersList',
        meta: {
            title: '訂單管理',
            description: '訂單流程處理與付款核對',
            orderDeskProfile: ORDER_DESK_PROFILE.FULL
        }
    },
    {
        path: '/products/finance-orders',
        component: () => import('@/views/forms/FinanceOrders.vue'),
        name: 'FinanceOrders',
        meta: {
            title: '財務對帳',
            description: '財務對帳、發票與報表匯出',
            orderDeskProfile: ORDER_DESK_PROFILE.FINANCE
        }
    },
    {
        path: '/products/order-cancellations',
        component: OrderCancellations,
        name: 'OrderCancellations',
        meta: {
            title: '訂單取消審核',
            orderDeskProfile: ORDER_DESK_PROFILE.FINANCE
        }
    }
];

/** 行銷／課程唯讀捷徑（同一元件，profile=readonly） */
export const orderDeskReadonlyLegacyRoutes = [
    {
        path: '/products/orders-readonly',
        component: OrdersList,
        name: 'OrdersListReadonly',
        meta: {
            title: '訂單查詢',
            hidden: true,
            orderDeskProfile: ORDER_DESK_PROFILE.READONLY
        }
    }
];
